import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import AuthenticationFactorList from 'Components/ComponentLibrary/Organisms/AuthenticationFactorList';
import {
  useWorkflowLayoutContext,
} from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';

export const AuthnMfaResetLayoutAuthFactorList = () => {
  const { setIsContentShowing } = useWorkflowLayoutContext();
  const { resource } = useMetaLayoutContext();

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return resource.withRelationship(fr.relationships.authenticationFactor.name, (rel) => {
    return (
      <AuthenticationFactorList
        authFactorsRelationship={rel}
        ListProps={{
          onMount: () => setIsContentShowing(true),
        }}
        hasUserSettingsRevampRelationship
      />
    );
  }, () => null);
};
